"use client";
import {
  MenubarProvider
} from "../__chunks/O5VVHQKK.js";
import "../__chunks/62UHHO2X.js";
import "../__chunks/BKQBQI36.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import {
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-bar-provider.tsx
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
function MenuBarProvider(props = {}) {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        "MenuBarProvider is deprecated. Use MenubarProvider instead.",
        "See https://ariakit.org/reference/menubar-provider"
      );
    }
  }, []);
  return /* @__PURE__ */ jsx(MenubarProvider, __spreadValues({}, props));
}
export {
  MenuBarProvider
};
